<adapt-two-column-page>
    <div left-column>
        <adapt-dashboard-element name="Activity Areas">
            <dx-list [dataSource]="items"
                     [grouped]="true"
                     [collapsibleGroups]="false"
                     selectionMode="single"
                     [focusStateEnabled]="false"
                     (onSelectionChanged)="onSelectionChanged($event)"
                     (onContentReady)="onContentReady($event)">
                <div *dxTemplate="let data of 'group'">
                    <div class="list-group">{{ data.key }}</div>
                </div>
                <div *dxTemplate="let data of 'item'">
                    <div class="list-item">{{ data.name }}</div>
                </div>
            </dx-list>
        </adapt-dashboard-element>
    </div>

    <div right-column>
        @if (team) {
            <div>
                <adapt-dashboard-element name="{{ team.name }} group activity"
                                         [url]="teamUrl$ | async">
                    <adapt-team-activity-feed [team]="team"
                                              feedTitle=""> </adapt-team-activity-feed>
                </adapt-dashboard-element>
            </div>
        } @else {
            <adapt-dashboard-element name="Organisation activity">
                <adapt-organisation-activity-feed></adapt-organisation-activity-feed>
            </adapt-dashboard-element>
        }
    </div>
</adapt-two-column-page>
